<div class="row my-row">
    <aside class="col-md-3 my-col" id="sticky-sidebar">
        <div class="sidenav bd-sidebar">
            <ul class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <li class="nav-item">
                    <a [ngClass]="this.router.url == '/superAdmin' ? 'nav-link active' : 'nav-link'" [routerLink]="'/superAdmin'">
                        <em class="bi bi-house-door"></em>
                        <span class="mx-1" style="vertical-align: top;">{{ "SUPER-ADMIN.SIDE-MENU.HOME-ADMIN" | translate }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a [ngClass]="this.router.url == '/superAdmin/psAdmin' ? 'nav-link active' : 'nav-link'" [routerLink]="'psAdmin'">
                        <em class="bi bi-person"></em>
                        <span class="mx-1" style="vertical-align: top;">{{ "SUPER-ADMIN.SIDE-MENU.PS-ADMIN" | translate }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a [ngClass]="this.router.url == '/superAdmin/clientAdmin' ? 'nav-link active' : 'nav-link'" [routerLink]="'clientAdmin'">
                        <em class="bi bi-building"></em>
                        <span class="mx-1" style="vertical-align: top;">{{ "SUPER-ADMIN.SIDE-MENU.CLIENT-ADMIN" | translate }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </aside>

    <div class="col-12 col-md-9 my-col" id="main">
        <router-outlet></router-outlet>
    </div>
</div>
